import React, { useEffect, useState } from 'react';
import styles from "../style/BosSideBar.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { Button, Checkbox } from 'antd';
import { accountHandle } from '../../Account/state/actions';

export default function BosSideBar() {
    const [intitialValues, setIntitialValues] = useState({});
    const { allBackOfficeData } = useSelector((state) => state.account);
    const dispatch = useDispatch();

    useEffect(()=>{
    const ner = structuredClone(allBackOfficeData);
    for(let group of ner){
        if(group.checked){
        setIntitialValues({...group});
        break;
        }
    }
    }, [allBackOfficeData]);

    const handleBos = () => {
        dispatch(accountHandle.handleCheckBosFirms({data: intitialValues}));
    };

    const handleCheckBoxChange = (e, id) => {
        let checked = e.target.checked;
        let cloneValue = {
          ...intitialValues
        }
        for(let i=0 ; i<(cloneValue?.parentData?.length || []); i++){
          const brokerage = cloneValue?.parentData[i];
          if(brokerage?._id === id){
            if(checked) brokerage.checked = true;
            else brokerage.checked = false;
            break;
          }
          let found = false;
          for(let j=0 ; j<(brokerage?.parentData?.length || []); j++){
            const office = brokerage?.parentData[j];
            if(office?._id === id){
              if(checked) office.checked = true;
              else office.checked = false;
              found = true;
              break;
            };
          }
          if(found) break;
        }
        setIntitialValues(cloneValue);
    }

    const checkedBrokerageGroupId = (groups, type) => {
        for(let group of groups){
          if(group.checked){
            if(type === "ID") return group._id;
            const allArray = [];
            for(let brokerage of group?.parentData){
              if(brokerage.checked) (type === "NAME") ? allArray.push(brokerage.name) : allArray.push(brokerage._id);
              for(let office of brokerage?.parentData){
                if(office.checked) (type === "NAME") ? allArray.push(office.name) : allArray.push(office._id);
              }
            }
            return allArray;
          }
        }
        return [];
    }

    return (
        <div className={styles.container}>
            <div className={styles.headingBox}>
                <div>Branch Offices</div>
                <Button type="primary" size='small' onClick={handleBos} disabled={(checkedBrokerageGroupId([intitialValues]))?.length === 0}>
                    Apply
                </Button>
            </div>
            <div>
                {   (Array.isArray(intitialValues?.parentData) && (intitialValues?.parentData?.length > 0)) && <div>
                    {
                        intitialValues?.parentData?.map((brokerage, idx)=>{
                            return <div>
                                {
                                    brokerage?.parentData?.map((office, index)=>{
                                        return <div>
                                            <Checkbox style={{ color: "#7f8082", fontSize: "16px", fontWeight: "600", padding: "5px 0px", width: "100%", display: "grid", gridTemplateColumns: "5% 92%", gridTemplateRows: "5px", gap: "3%" }} checked={office?.checked} onChange={(checked)=>handleCheckBoxChange(checked, office?._id)}>
                                                <div style={{display: "flex", gap: "2%", alignItems: "center", width: "100%"}}>
                                                    <div style={{width: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{office?.name}</div>
                                                    <div style={{width: "20px", height: "15px", backgroundColor: office?.backgroundColor}}></div>
                                                </div>
                                            </Checkbox>
                                        </div>
                                    })
                                }
                            </div>
                        })
                    }
                    
                </div>}
            </div>
        </div>
    )
}
